export default {
    title: "Детальная информация",

    position: {
        label: "Позиция документа",
        placeholder: "Выберите позицию",
        id: "ID",
        product: "Товар",
        quantity: "Количество",
    },

    tabs: {
        main: "Основное",
        product: "Товар",
        bank: "Банк",
        prices: "Цены",
        delivery: "Поставка",
    },

    main: {
        id: "ID",
        lotId: "Lot ID",
        vat: "НДС",
        unit: "Единица измерения",
        quantity: "Количество",
        expense: "Расход",
        country: "Страна",
        countryCode: "Код страны",
        claimId: "Claim ID",
        description: "Описание",
    },

    product: {
        id: "ID",
        code: "Код",
        name: "Наименование",
    },

    bank: {
        klsId: "KLS ID",
        name: "Наименование KLS",
        bank: "Банк",
        company: "Компания",
        account: "Банковский счёт",
        mfo: "МФО",
        accountType: "Тип счёта",
    },

    prices: {
        unitPrice: "Цена за единицу",
        suggestedPrice: "Предложенная цена",
        totalCost: "Общая стоимость",
        suggestedTotalCost: "Предложенная общая стоимость",

        withoutVat: "Без НДС",
        vat: "НДС",
        withVat: "С НДС",
    },

    delivery: {
        period: "Период поставки",
        days: "Срок поставки",
        daysValue: "{{count}} дней",
        schedule: "График поставки",

        year: "Год",
        month: "Месяц",
        quantity: "Количество",
        advancePayment: "Аванс",

        empty: "График поставки отсутствует",
    },

    common: {
        dash: "—",
        noData: "Нет данных для отображения",
        selectPosition: "Выберите позицию",
    },
};